module.exports = __webpack_public_path__ + "img/fujin@2x.61e4ff27.png";